import { IntlTFunc } from 'next-intl';

import { FilterOption, Filters } from '@/fo/ui/product/layout/catalog';

/** Добавляет опцию "Со скидкой" в существующий toggleList фильтр или создает отдельный */
export const addDiscountFilterOption = (
  filters: Filters,
  t: IntlTFunc
): Filters => {
  const discountOption: FilterOption = {
    label: t('sortOptions.discount'),
    value: 'only_with_discount',
    slug: 'only_with_discount'
  };

  // Ищем первый toggleList фильтр (label или brand)
  const toggleListIndex = filters.mainFilters.findIndex(
    (filter) => filter.type === 'toggleList' && filter.slug === 'label'
  );

  // Если нашли toggleList фильтр, добавляем опцию в начало
  if (toggleListIndex !== -1) {
    const updatedFilters = [...filters.mainFilters];
    const targetFilter = updatedFilters[toggleListIndex];

    // Проверяем, что фильтр имеет массив опций
    if (
      targetFilter.type === 'toggleList' &&
      Array.isArray(targetFilter.options)
    ) {
      // Проверяем, что опция еще не добавлена
      const hasDiscount = targetFilter.options.some(
        (opt: FilterOption) => opt.value === 'only_with_discount'
      );

      if (!hasDiscount) {
        updatedFilters[toggleListIndex] = {
          ...targetFilter,
          options: [discountOption, ...targetFilter.options]
        };
      }
    }

    return {
      ...filters,
      mainFilters: updatedFilters
    };
  }

  // Если toggleList фильтров нет, создаем отдельный фильтр в начале
  return {
    ...filters,
    mainFilters: [
      {
        type: 'toggleList',
        slug: 'label',
        options: [discountOption]
      },
      ...filters.mainFilters
    ]
  };
};
